import React from 'react';

class Card extends React.Component{

	constructor(props) {
		super(props);
    this.handleHover = this.handleHover.bind(this);
    this.state = {
      highlight : false
    };
	}

  handleHover() {
    this.setState({highlight: !this.state.highlight});
  }




	render() {
        function createMarkup(input) {
          return {
            __html: input
          }
        }

        let project = this.props.project;

        var highlight = this.state.highlight ?
                          'recent-card-wrapper highlight' :
                          'recent-card-wrapper';


        return (
            <div className={ highlight } id={ project.uuid }>
                <div className="recent-meta-wrapper">
                  <div className="recent-card-headline">
                    <h3>
                        <a
                          href={ project.destination }
                          onMouseOver={this.handleHover}
                          onMouseOut={this.handleHover}>
                          { project.headline }
                        </a>
                    </h3>
                  </div>
                  <p
                    className="recent-card-description"
                    dangerouslySetInnerHTML={ createMarkup(project.description) }
                  />
                </div>
								<div className="recent-image-wrapper">
									<a href={ project.destination }>
										<img
                      src={ project.promo_image }
                      onMouseOver={this.handleHover}
                      onMouseOut={this.handleHover} />
									</a>
								</div>
            </div>
		);
	}
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/LandingPage/Recent/Card.js